/**
 * Community journey quotes shown on marketing surfaces.
 */
import { buildCollection } from "@firecms/core";
import { editorOrAdminPermissions } from "../permissions";
import { CONTENT_STATUS_ENUM } from "../lib/contentStatus";
import {
  STATUS_FIELD_DESCRIPTION,
  publishedSnapshotProperties,
} from "../lib/publishedSnapshotProperties";
import { collectCommunityStoryCompletenessIssues } from "../lib/completenessValidation";
import { localizedStringProperties } from "../lib/localeMaps";
import { createStatusPreSave } from "../lib/statusPreSave";

export const communityStoriesCollection = buildCollection({
  id: "community_stories",
  name: "Community Stories",
  singularName: "Community Story",
  path: "community_stories",
  icon: "Forum",
  group: "Site",
  permissions: editorOrAdminPermissions,
  callbacks: {
    onPreSave: createStatusPreSave({
      collectCompleteness: collectCommunityStoryCompletenessIssues,
      entityLabel: "community story",
    }),
  },
  properties: {
    quote: {
      name: "Quote",
      dataType: "map",
      properties: localizedStringProperties(),
    },
    author_name: {
      name: "Author name",
      dataType: "string",
      validation: { required: true },
    },
    tier_level: {
      name: "Tier level",
      dataType: "number",
      description: "1–4 (Traveler → Vanguard)",
    },
    tier_label: {
      name: "Tier label",
      dataType: "string",
      description: "Traveler, Pioneer, Navigator, or Vanguard",
      validation: { required: true },
    },
    image_url: {
      name: "Image URL",
      dataType: "string",
    },
    alt_text: {
      name: "Image alt text",
      dataType: "map",
      properties: localizedStringProperties(),
    },
    sort_order: {
      name: "Sort order",
      dataType: "number",
      description: "Lower numbers appear first",
    },
    status: {
      name: "Status",
      dataType: "string",
      enumValues: CONTENT_STATUS_ENUM,
      description: STATUS_FIELD_DESCRIPTION,
    },
    ...publishedSnapshotProperties,
    created_at: {
      name: "Created At",
      dataType: "date",
      autoValue: "on_create",
    },
    updated_at: {
      name: "Updated At",
      dataType: "date",
      autoValue: "on_update",
    },
  },
});
